import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { accountApi, getToken, setToken } from "@/lib/customerApi";

const Ctx = createContext(null);

export function CustomerProvider({ slug, children }) {
  const api = useMemo(() => accountApi(slug), [slug]);
  const [customer, setCustomer] = useState(null);
  const [ready, setReady] = useState(!getToken(slug));     // no token = nothing to check

  useEffect(() => {
    setCustomer(null);
    if (!getToken(slug)) { setReady(true); return undefined; }
    let live = true;
    setReady(false);
    api.get("/me").then(({ data }) => live && setCustomer(data)).catch(() => {}).finally(() => live && setReady(true));
    return () => { live = false; };
  }, [slug, api]);

  useEffect(() => {
    const out = (e) => { if (e.detail === slug) setCustomer(null); };
    window.addEventListener("s24c:logout", out);
    return () => window.removeEventListener("s24c:logout", out);
  }, [slug]);

  const signIn = useCallback((data) => { setToken(slug, data.token); setCustomer(data.customer); setReady(true); }, [slug]);
  const signOut = useCallback(() => { setToken(slug, null); setCustomer(null); }, [slug]);
  const value = useMemo(() => ({ api, customer, setCustomer, ready, signIn, signOut, slug }), [api, customer, ready, signIn, signOut, slug]);
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export const useCustomer = () => useContext(Ctx);
